import React, {useReducer, useCallback} from 'react'
import getEntitiesReducer from '../../state/entities/get-entities/reducer'
import getEntityReducer from '../../state/entities/get-entity/reducer'
import getUsersReducer from '../../state/user/get-user/reducer'
import getTemplatesReducer from '../../state/user/get-user-templates/reducer'

import {getEntities, setEntities} from '../../state/entities/get-entities/actions'
import {getEntityChildData} from '../../state/entities/get-entity-child-fields/actions'
import {
  getEntity,
  setEntity,
  getEntityUserFieldData,
  getEntityAutoFieldData,
  getEntityAutoUpdateFieldsValuesData,
  getEntityFilterFieldData,
  getEntitySearchFilterFieldData,
  setEntityReloading,
} from '../../state/entities/get-entity/actions'
import {
  getUser,
  getSearchUser,
  getSearchUserEmail,
  updateSearchUser,
} from '../../state/user/get-user/actions'
import {getUserTemplate, getSearchTemplate} from '../../state/user/get-user-templates/actions'

const AuditModalApiContext = React.createContext()

function AuditModalApiContextProvider(props) {
  const groupState = {
    groups: [],
    error: null,
    isLoading: false,
  }

  const entityState = {
    entities: {
      entities_details: [
        {
          id: null,
          fields: [],
          filters: [],
          auto_update_fields: [],
          auto_update_fields_values: [],
          user_update_fields: [],
        },
      ],
    },
    error: null,
    isLoading: false,
    isFieldLoading: false,
    isFilterLoading: false,
    isAutoFieldLoading: false,
    isUserFieldLoading: false,
    isAutoFieldValueLoading: false,
  }

  const userState = {
    users: [],
    userEmails: [],
    error: null,
    isLoading: false,
  }

  const templateUserState = {
    error: null,
    isLoading: true,
  }

  const [groups, groupsDispatch] = useReducer(getEntitiesReducer, groupState)
  const getAllEntities = useCallback(() => getEntities(groupsDispatch), [])
  const resetEntities = useCallback(() => setEntities(groupsDispatch), [])

  const [entities, entitiesDispatch] = useReducer(getEntityReducer, entityState)
  const getEntityFields = useCallback(id => getEntity(id, entitiesDispatch), [])
  const getEntityUserFields = useCallback(id => getEntityUserFieldData(id, entitiesDispatch), [])
  const getEntityAutoFields = useCallback(id => getEntityAutoFieldData(id, entitiesDispatch), [])
  const getEntityAutoFieldsValues = useCallback(
    (id, fieldId) => getEntityAutoUpdateFieldsValuesData(id, fieldId, entitiesDispatch),
    []
  )

  const getEntityFilterFields = useCallback(
    (id, filter) => getEntityFilterFieldData(id, filter, entitiesDispatch),
    []
  )
  const resetFilterReloading = useCallback(() => setEntityReloading(entitiesDispatch), [])
  const resetEntityDetails = useCallback(() => setEntity(entitiesDispatch), [])
  const getSearchFilterFields = useCallback(
    (id, search) => getEntitySearchFilterFieldData(id, search, entitiesDispatch),
    []
  )

  const getEntityChild = useCallback(params => getEntityChildData(params, entitiesDispatch), [])

  const [users, userDispatch] = useReducer(getUsersReducer, userState)
  const getUsers = useCallback(() => getUser(userDispatch), [])
  const getSearchUsers = useCallback(search => getSearchUser(search, userDispatch), [])
  const getSearchUserEmails = useCallback(search => getSearchUserEmail(search, userDispatch), [])
  const updateSearchUsers = useCallback(users => updateSearchUser(users, userDispatch), [])

  const [userTemplates, templateUsersDispatch] = useReducer(getTemplatesReducer, templateUserState)
  const getUserTemplates = useCallback(() => getUserTemplate(templateUsersDispatch), [])
  const getSearchTemplates = useCallback(
    search => getSearchTemplate(search, templateUsersDispatch),
    []
  )

  const value = {
    groups,
    entities,
    users,
    userTemplates,

    getAllEntities,
    getEntityFields,
    getEntityUserFields,
    getEntityAutoFields,
    getEntityAutoFieldsValues,
    getEntityFilterFields,
    resetFilterReloading,
    getUsers,
    getSearchUsers,
    getSearchUserEmails,
    getUserTemplates,
    getSearchTemplates,
    updateSearchUsers,
    resetEntities,
    resetEntityDetails,
    getEntityChild,
    getSearchFilterFields,
  }

  return (
    <AuditModalApiContext.Provider value={value}>{props.children}</AuditModalApiContext.Provider>
  )
}

const AuditContextConsumer = AuditModalApiContext.Consumer

export {AuditModalApiContext, AuditModalApiContextProvider, AuditContextConsumer}
